import { render, staticRenderFns } from "./attachment-form.html?vue&type=template&id=1233271d&scoped=true&external"
import script from "./attachment-form.js?vue&type=script&lang=js&external"
export * from "./attachment-form.js?vue&type=script&lang=js&external"
import style0 from "./attachment-form.scss?vue&type=style&index=0&id=1233271d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233271d",
  null
  
)

export default component.exports